import { ActiveFilter } from 'proto/Search/ActiveFilter';

import { IndividualTravelFilter } from '../types';

const individualTravelFilter: string[] = [
    IndividualTravelFilter.Diving,
    IndividualTravelFilter.Golfing,
    IndividualTravelFilter.Kitesurfing,
    IndividualTravelFilter.Surfing,
    IndividualTravelFilter.Watersports,
    IndividualTravelFilter.Windsurfing,
    IndividualTravelFilter.Wingfoiling,
    IndividualTravelFilter.Wintersport,
];

export const getActiveIndividualHotelFilter = (filterList: ActiveFilter[]) =>
    filterList
        .filter((item) => individualTravelFilter.includes(item.key))
        .map((item) => item.label);
